<template>
  <div
    class="content-body rounded-2 white d-flex justify-content-start align-items-center nowrap w-100"
  >
    <div
      class="section-one d-flex justify-contemt-start align-items-center nowrap nowrap"
    >
      <div class="left">
        <div class="avatar avatar-square brand_inverse_light_bg">
          <span class="icon-library brand_navy flex-center font-19"></span>
        </div>
      </div>
      <div class="right">
        <div class="title-text brand_navy font-weight-bold">
          {{ title }}
        </div>
        <div class="subject-text color_grey_dark">{{ subject }}</div>
      </div>
    </div>

    <div class="section-two">{{ date }}</div>

    <div class="section-three">{{ class_year }}</div>

    <!-- SUBSCRIPTION -->
    <div class="section-four">{{ teacher_name }}</div>
    <!-- SUBSCRIPTION -->

    <!-- OPTIONS -->
    <div class="section-five">
      <router-link
        :to="{ name: 'HomeworkReview', params: { homework_id: id } }"
        class="btn-link link-no-underline font-weight-bold"
        >View</router-link
      >
    </div>
    <!-- OPTIONS -->
  </div>
</template>

<script>
export default {
  name: "WeeklyHomeworkRow",

  components: {},

  props: {
    id: Number,
    title: String,
    subject: String,
    date: String,
    teacher_name: String,
    class_year: {
      type: String,
      default: "No class year set",
    },
  },

  computed: {},

  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.content-body {
  padding: 12px 10px;
  margin-bottom: 2px;
  font-size: 14px;
  line-height: 19px;
  color: $color_ash;

  @include breakpoint_max(lg) {
    font-size: 12px;
    line-height: 17px;
    padding: 8px;
  }

  @include breakpoint_max(lg) {
    font-size: 11px;
    line-height: 13px;
  }

  .section-one {
    width: 43%;

    @include breakpoint_max(md) {
      width: 60%;
    }

    @include breakpoint_custom_max(430) {
      width: 80%;
    }

    .avatar {
      @include equal_min_edge(40);
      margin-right: 10px;

      @include breakpoint_max(lg) {
        @include equal_min_edge(36);
      }

      @include breakpoint_max(sm) {
        @include equal_min_edge(36);
      }
    }

    .title-text {
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 2px;

      @include breakpoint_max(lg) {
        font-size: 12.5px;
        line-height: 17px;
      }

      @include breakpoint_max(md) {
        font-size: 12px;
        line-height: 16px;
      }
    }
    .subject-text {
      font-size: 12px;
      line-height: 16px;

      @include breakpoint_max(lg) {
        font-size: 11.5px;
        line-height: 15px;
      }

      @include breakpoint_max(md) {
        font-size: 11px;
        line-height: 13px;
      }
    }
  }

  .section-two {
    width: 30%;

    @include breakpoint_max(md) {
      width: 40%;
    }

    @include breakpoint_max(xs) {
      width: 35%;
    }

    @include breakpoint_custom_max(430) {
      display: none;
    }
  }

  .section-three {
    width: 25%;

    @include breakpoint_max(md) {
      display: none;
    }
  }

  .section-four {
    width: 30%;

    @include breakpoint_max(md) {
      display: none;
    }
  }

  .section-five {
    width: 12%;
    font-size: 13px;
    line-height: 140%;

    @include breakpoint_max(lg) {
      font-size: 12px;
    }

    @include breakpoint_max(md) {
      width: 18%;
    }

    @include breakpoint_max(xs) {
      width: 15%;
    }
  }
}
</style>